export default __webpack_public_path__ + "static/media/requirements-sidebar.6a20b8ab.jpg";